var React = require('react');

function PhoneIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.9999 3H14.9999V0H12.9999V3H9.9999V5H12.9999V8H14.9999V5H17.9999V3ZM17.9999 12.46L12.7299 11.85L10.2099 14.37C7.3799 12.93 5.0599 10.62 3.6199 7.78L6.1499 5.25L5.5399 0H0.0299025C-0.550097 10.18 7.8199 18.55 17.9999 17.97V12.46Z","fill":"#091034"}));
}

PhoneIconInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = PhoneIconInline;

PhoneIconInline.default = PhoneIconInline;
